module.exports = __webpack_public_path__ + "static/img/nonghuazhan.250cefea.png";